import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div>
      <div id="footer">
        <div className="container text-center">
          <p>
            Copyright &copy; {new Date().getFullYear()}{" "}
            <Link to="/" rel="nofollow">
              iTreasure Kids
            </Link>{" "}
            |{" "}
            <Link to="/policy" rel="nofollow">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms" rel="nofollow">
              Terms & Conditions
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
